export default "__VITE_ASSET__rr$JUqlY__"